import React from 'react';
import compareSize from '../helpers/compareSize';
import compareColor from '../helpers/compareColor';

class ListItemsOverview extends React.Component {
    _calculateItems = (items) => {
        const total = [];

        for (const item of items) {
            let {products} = item

            if (item.hasOwnProperty('filteredProducts')) {
                products = item.filteredProducts
            }

            for (const product of products) {
                const color = typeof product.color === 'string' ? product.color.toUpperCase().trim() : '';
                const size = typeof product.size === 'string' ? product.size.toUpperCase().trim() : '';
                const quantity = parseInt(product.quantity);

                const find = total.find(totalItem => totalItem.color === color && totalItem.size === size);
                if (find) {
                    find.sum += quantity;
                } else {
                    total.push({color, size, sum: quantity});
                }
            }
        }

        return total;
    };

    _getSum = (total, color, size) => {
        const item = total.find(totalItem => totalItem.color === color.toUpperCase() && totalItem.size === size.toUpperCase());
        if (item) return item.sum || 0;
        return 0;
    };

    _getSumKey = (total, key, value) => {
        const filteredItems = total.filter(item => item[key].toUpperCase() === value.toUpperCase());
        return filteredItems.reduce((sum, item) => sum + item.sum, 0);
    };

    _getColors = (total) => {
        const colors = [];
        for (let item of total) {
            const color = item.color.toUpperCase();
            if (!colors.includes(color)) colors.push(color);
        }
        return colors;
    };

    _getSizes = (total) => {
        const sizes = [];
        for (let item of total) {
            const size = item.size.toUpperCase();
            if (!sizes.includes(size)) sizes.push(size);
        }
        return sizes;
    };

    _getTotalSum = (total) => {
        return total.reduce((sum, item) => sum + item.sum, 0);
    };

    render() {
        const {items} = this.props;
        const total = this._calculateItems(items);
        const colors = this._getColors(total).sort(compareColor);
        const sizes = this._getSizes(total).sort(compareSize);
        const totalSum = this._getTotalSum(total);

        return (
            <div className='table-responsive'>
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th>Color</th>
                        {
                            sizes.map(size => {
                                return <th key={size}>{size}</th>;
                            })
                        }
                        <th>Total: {totalSum}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        colors.map(item => {
                            return <tr key={item}>
                                <td>{item}</td>
                                {
                                    sizes.map(size => {
                                        return <td key={size}>{this._getSum(total, item, size)}</td>;
                                    })
                                }
                                <td>{this._getSumKey(total, 'color', item)}</td>
                            </tr>;
                        })
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default ListItemsOverview;
